import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import LiveChat from './LiveChat';
import ScrollToTop from './ScrollToTop';

const Layout = ({ children }) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-800 relative">
      <div
        className="fixed top-0 left-0 h-1 bg-gradient-to-r from-primary-500 via-primary-400 to-primary-600 z-[100] transition-all duration-150"
        style={{ width: `${scrollProgress}%` }}
      />

      <Navbar />
      <main className="relative">{children}</main>
      <Footer />
      <LiveChat />
      <ScrollToTop />
    </div>
  );
};

export default Layout;
